<template>
    <b-form-row class="mb-1 mt-1" v-if="company&&company.id">
        <b-col>
            {{ company.title }}
        </b-col>
        <b-col cols="1">
            <input type="hidden" v-model="company.id"/>
            <b-button variant="outline" size="sm" v-on:click="removeItem">
                <b-icon-x aria-hidden="true"></b-icon-x>
            </b-button>
        </b-col>
    </b-form-row>
    <b-form-row v-else>
        <b-col>
            <i>Нет</i>
        </b-col>
    </b-form-row>
</template>

<script>
    export default {
        name: "CompanyListEntry",
        props: ["company"],
        methods: {
            removeItem() {
                this.$emit('removeItem', this.company.id);
            }
        }
    }
</script>

<style scoped>

</style>